module.exports = __webpack_public_path__ + "img/mecha-13.c7d21b45.jpg";